<script setup> 
  import { useWebviewMessenger } from '@/helpers/webview';

  const props = defineProps({
    spotId: {
      type: [String, Number],
      required: true
    }
  });

  const webViewMessenger = useWebviewMessenger();

  const handleOpenCompleteReportClick = () => {
    webViewMessenger.send({
      type: 'open-complete-report',
      spotId: props.spotId
    })
  };
</script>

<template>
  <button
    @click.prevent="handleOpenCompleteReportClick"
    class="jwx-block__title-action"
  >
    <slot></slot>
  </button>
</template>